/* eslint-disable */
import React, { useState, useRef, useEffect } from "react";
import upArrow from "assets/images/organisationProfile/setup/select arrow.svg";
import upArrowDark from "assets/images/organisationProfile/setup/selectArowdark.svg";
import { permission } from "constants/setup/countries";
import useTheme from "hooks/observer";

import "./multiSelectDropDown.scss";
import Button from "components/Button/index";
import SquareCheckBox from "components/SquareCheckBox";

const MultiSelectDropDown = ({
  selectedCountries = [],
  onSelectCountries,
  label = "Location",
  data ={permission},
  width = "100%",
  star = "",
  placeholder = "Select countries"
}) => {
  // console.log("selected countries", selectedCountries);
  // console.log("data/permissions", data);
  // Remove empty string entries from selectedCountries
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [tempSelectedCountries, setTempSelectedCountries] =
    useState(selectedCountries);
  const theme = useTheme();
  const dropdownRef = useRef(null);

  const arrow = theme === "light" ? upArrow : upArrowDark;

  const toggleDropdown = () => {
    setDropdownOpen((prev) => !prev);
  };

  useEffect(() => {
    if (dropdownOpen) {
      setTempSelectedCountries(selectedCountries); // sync current selection
    }
  }, [dropdownOpen, selectedCountries]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setDropdownOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleCountryToggle = (country) => {
    const updated = tempSelectedCountries.includes(country)
      ? tempSelectedCountries.filter((c) => c !== country)
      : [...tempSelectedCountries, country];
    setTempSelectedCountries(updated);
  };

  const handleCancel = () => {
    // setLoading(false);
    setTempSelectedCountries([]); // reset selection
    setDropdownOpen(false);
  };
  const handleSelect = () => {
    onSelectCountries(tempSelectedCountries); // apply selection
    setDropdownOpen(false);
  };

  return (
    <div className="multiSelectDropDownContainer">
      <label htmlFor="multiSelect" className="form-label">
        {label} <span>{star}</span>
      </label>

      <div
        id="multiSelect"
        className="form-select"
        onClick={toggleDropdown}
        ref={dropdownRef}
      >
        <div className="selected-values">
          {selectedCountries.length > 0 ? (
            selectedCountries.map((country) => (
              <span className="selected-tag" key={country}>
                {country}
              </span>
            ))
          ) : (
            <span>{placeholder}</span>
          )}
        </div>
        <img src={arrow} alt="select" />

        {dropdownOpen && (
          <div
            className="dropdownList countryDropdown"
            id="multiCountryDropdown"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="dropdown-scroll-area">
              {data.map((country, index) => (
                <div
                  key={index}
                  className="dropdownItem"
                  onClick={(e) => e.stopPropagation()}
                >
                  <SquareCheckBox
                    label={country}
                    isChecked={tempSelectedCountries.includes(country)}
                    isDisable={false}
                    onChange={() => handleCountryToggle(country)}
                  />
                </div>
              ))}
            </div>

            <div className="footerButtons">
              <Button
                type="white"
                title="Cancel"
                width="50%"
                onClick={handleCancel}
              />
              <Button
              // loading={loading}
                type="violet"
                title="Select"
                width="50%"
                onClick={handleSelect}
              />
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default MultiSelectDropDown;
